// sorry, don't know how to translate
const POCATENCNI_KOJENECKA_MLEKA_TYPE = 68174;

export function isInfantFormula(product: { navigationValues: number[] }) {
  return product.navigationValues.includes(POCATENCNI_KOJENECKA_MLEKA_TYPE);
}
